'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../tslib.es6-cd939937.js');
var ams_getApiKey = require('./getApiKey.js');
var ams_getDeviceInfo = require('./getDeviceInfo.js');
require('../md5.js');
require('../device.js');
require('ua-parser-js');
require('../normalizeLang.js');
require('../languages.js');
require('../deviceAsync.js');

function generateHeaders(customHeaders, accessData, fullList) {
    if (customHeaders === void 0) { customHeaders = {}; }
    if (fullList === void 0) { fullList = false; }
    return tslib_es6.__awaiter(this, void 0, void 0, function () {
        var headers, _a, _b, time;
        return tslib_es6.__generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    accessData = Object.assign({}, accessData);
                    headers = {
                    // "PrivateId": Config.get('authInfo.privateId'),
                    // "sid": Config.get('authInfo.sid'),
                    // "udid": Config.get('authInfo.device_id'),
                    // "api_key": getApiKey(time),
                    // "Api-Version": Config.get('appInfo.Api-Version'),
                    // "Device-Info": Config.get('appInfo.Device-Info'),
                    // "time": time,
                    };
                    if (accessData.sid) {
                        headers.sid = accessData.sid;
                    }
                    if (accessData.dat) {
                        headers.dat = accessData.dat;
                    }
                    if (accessData.privateId) {
                        headers[accessData.customer === 'zman' ? 'user' : 'privateId'] = accessData.privateId;
                    }
                    if (accessData.device_id) {
                        headers.udid = accessData.device_id;
                    }
                    _a = headers;
                    _b = 'Device-Info';
                    return [4 /*yield*/, ams_getDeviceInfo.getDeviceInfoAsync(accessData)];
                case 1:
                    _a[_b] = _c.sent();
                    if ((fullList && accessData.privateId && accessData.sid && accessData.device_id && accessData.public_app_key) || !fullList) {
                        time = parseInt(String(Date.now() / 1000));
                        if (accessData['Api-Version']) {
                            headers['Api-Version'] = accessData['Api-Version'];
                        }
                        headers['api_key'] = ams_getApiKey.getApiKey(time, customHeaders || {}, accessData);
                        headers['time'] = time;
                    }
                    return [2 /*return*/, Object.assign(headers, customHeaders || {})];
            }
        });
    });
}

exports.generateHeaders = generateHeaders;
